import Data from "./data.json";
export const SESSION_HEADER = "Authorization";
export const LOCAL_SESSION_ID = "sessionId";
export const LOCAL_USER_ID = "userId";
export const LOCAL_ROLES = "roles";
export const LOCAL_AUTH_PROVIDER = "authProvider";
export const LOCAL_SSO_APP_ID = "ssoAppId";
export const BAD_REQUEST_FRONT_MSG = "Respuesta inapropiada del servidor comuniquese al administrador.";
export const TENANT_CODE_VALIDATION_MSG_FRONT = "TenantCode Must be defined";
export const ROUTE_PATH_ERROR_MSG_FRONT = "Route Path Error.";
export const DEFAULT_URL_LOGO = "/public/img/adevslogo.png";
export const APP_BAR_HEIGHT = 64;
export const DEFAULT_COLORS = Data.apps?.[0]?.app_colors || {
  primary: { main:'#3951DB', light:'#5C73F2', dark:'#2A3CA6', contrastText:'#ffffff' },
  secondary: { main:'#FF7536', light:'#FF9360', dark:'#D95C24', contrastText:'#ffffff' },
  text: { primary:'#1D2939', secondary:'#475467', disabled:'#98A2B3', hint:'#D0D5DD' },
  others: { defaultColor:'#FCFCFD', paper:'#ffffff' },
};
